<template>
  <div>
    <v-overlay z-index="2" :value="overlay"></v-overlay>

    <div class="elevation-10 lxauth-login-container layout-column" style="z-index:4;position:fixed;left:50%;margin-left:-350px;top:50px;bottom:50px;width:700px;" v-if="welcome">
      <div class="px-4 pt-2">
        <v-toolbar color="transparent" dark flat>
          <v-toolbar-title class="layout-row layout-align-center-center" style="width: 100%;">
            <v-subheader class="text-center px-0 display-1 font-weight-black white--text my-2">
              {{ $t('AUTH.APP_NAME') }}
            </v-subheader>
          </v-toolbar-title>
        </v-toolbar>
      </div>
      <router-view id="authContainer" style="background:rgba(0,0,0,0.1)"></router-view>
    </div>

    <div class="elevation-10 lxauth-login-container" style="z-index:4;position:fixed;left:50%;margin-left:-350px;top:50%;margin-top:-285px;width:700px;min-height:570px;" v-if="!welcome">
      <div class="px-4 pt-2">
        <v-toolbar color="transparent" dark flat>
          <v-toolbar-title class="layout-row layout-align-center-center" style="width: 100%;">
            <v-subheader class="text-center px-0 display-1 font-weight-black white--text my-2">{{ $t('AUTH.APP_NAME') }}
              <span class="ml-6 font-weight-thin white--text" v-if="userRegister">  -  {{ $t('AUTH.REGISTER') }}</span>
              <span class="ml-6 font-weight-thin white--text" v-if="passwordReset">  -  {{ $t('AUTH.PASSWORD_RESET') }}</span>
            </v-subheader>
          </v-toolbar-title>
          <template v-slot:extension>
            <v-tabs
              color="white"
              background-color="transparent"
              slider-color="green"
              class="pl-6"
              v-show="!passwordReset && !userRegister"
            >
              <v-tab class="text-none px-5" to="/auth/login">{{ $t('AUTH.TAB_LOGIN') }}</v-tab>
              <v-tab class="text-none" to="/auth/forgot">{{ $t('AUTH.TAB_FORGOT_PASSWORD') }}</v-tab>
            </v-tabs>
          </template>
        </v-toolbar>
      </div>
      <router-view id="authContainer" style="background:rgba(0,0,0,0.1)"></router-view>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      overlay: true,
      dialog: true,
      appClassnames: '',
      activeTab: 1
    }
  },
  mounted () {
    let app = document.getElementById('mainApp')
    this.appClassnames = app.className
    app.className += ' authArea'
  },
  computed: {
    passwordReset () {
      return this.$route.name === 'NewPassword'
    },
    userRegister () {
      return this.$route.name === 'Register'
    },
    welcome () {
      return this.$route.name === 'Welcome'
    }
  },
  destroyed () {
    let app = document.getElementById('mainApp')
    app.className = this.appClassnames
  }
}
</script>
